import { QRCodeSVG } from 'qrcode.react';
import { FormattedMessage } from 'react-intl';
import { LogoImage } from 'src/app/LogoImage';
import { AppState } from 'src/AppState';
import { Trapeze } from 'src/easyclaim.app.assets/icons/Trapeze';
import { HandWithSolvdCJIcon } from 'src/easyclaim.app.components/common/ImageRepository';
import { MiniScreen } from 'src/easyclaim.app.components/common/MiniScreen';
import { CustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import { EasyClaimDocumentService } from 'src/easyclaim.app.services';

export const BlockedDeviceSolvd = ({
	appState,
	caseId,
	documentService,
}: {
	appState: AppState;
	caseId?: string;
	documentService?: EasyClaimDocumentService;
}) => {
	const context = CustomerConfiguration();

	if (!context || !context.frontendSteps) {
		return null;
	}

	return (
		<div className="blocked-on-desktop">
			<Trapeze className="trapeze" />
			<MiniScreen appState={appState}>
				<HandWithSolvdCJIcon />
			</MiniScreen>

			{caseId && documentService && <LogoImage caseId={caseId} documentService={documentService} />}
			<h2 className="blocked-headline">
				<FormattedMessage id="blockedByDevice.headline" />
			</h2>
			<div className="blocked-paragraph">
				<FormattedMessage id="blockedByDevice.paragraph.first" />
			</div>
			<div className="blocked-QR">
				<QRCodeSVG value={window.location.href} />
			</div>
			<div className="blocked-paragraph">
				<FormattedMessage id="blockedByDevice.paragraph.second" />
			</div>
		</div>
	);
};
